import { FC } from "react";
import Spinner from "./Spinner";
import { cn } from "@/lib/utils";

interface FullScreenProps {
  hasSpinner?: boolean;
  customCss?: string;
}

const FullScreen: FC<FullScreenProps> = (props) => {
  return (
    <div
      className={cn(
        "custom-full-screen-loader flex items-center justify-center",
        props.customCss
      )}
    >
      {props.hasSpinner ? (
        <Spinner />
      ) : (
        <p className="text-2xl text-bold">Loading...</p>
      )}
    </div>
  );
};

export default FullScreen;
